var getEnv = function getEnv() {
  var oRE = new RegExp("(?:; )?fed-env=([^;]*)");

  if (typeof document !== 'undefined' && oRE.test(document.cookie)) {
    return decodeURIComponent(RegExp.$1);
  }

  if (typeof process !== "undefined" && process.env) {
    return process.env.NODE_CONFIG_ENV || process.env.NODE_ENV;
  } //   无法获取到环境变量


  return "";
};

var main = getEnv;

export default main;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hz/env/es/index.js
// module id = 178
// module chunks = 28